module.exports = __webpack_public_path__ + "img/AGR-B-2-II.bcfedf73.png";